import swal from "sweetalert";
import * as utility from '../../utility/Utility';
import { globalLoadingAction } from './GlobalAction';
import {
    addSystemConfig,
    getSystemConfig,
    getSystemUserConfig,
    getSummaryConfig
} from '../../services/SystemDefaultService';

import {
    GET_SYSTEM_DEFAULT_LIST,
    GET_SYSTEM_USER_CONNFIC_DETAILS,
    GET_SYSTEM_USER_WEEKOFF_DETAILS,
    GET_SYSTEM_USER_LEAVE_DETAILS,
    GET_SUMMARY_CONNFIC_DETAILS
} from '../constants';


export function addSystemConfigData(config_data, history) {
    return (dispatch) => {
        addSystemConfig(config_data)
            .then((response) => {
                if (response.data.status == 200) {
                    utility.showSuccess(response.data.msg);
                } else {
                    utility.showError(response.data.msg);
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                //console.log(error);
                //utility.showError(response.data.msg);
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getSystemConfigData(systemAdmin, history) {
    return (dispatch) => {
        getSystemConfig(systemAdmin)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getSystemConfigAction(response.data));
                } else {
                    utility.showError(response.data.msg);
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                //console.log(error);
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getSystemUserConfigData(filter_type, system_admin, history) {
    return (dispatch) => {
        getSystemUserConfig(filter_type, system_admin)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getSystemUserConfigAction(response.data));
                } else {
                    utility.showError(response.data.msg);
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                //console.log(error);
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getSummaryConfigData(history) {
    return (dispatch) => {
        getSummaryConfig()
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getSummaryConfigAction(response.data.data));
                } else {
                    utility.showError(response.data.msg);
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                //console.log(error);
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getSystemUserWeekOffData(filter_type, system_admin, history) {
    return (dispatch) => {
        getSystemUserConfig(filter_type, system_admin)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getSystemUserWeekOffDataAction(response.data));
                } else {
                    utility.showError(response.data.msg);
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                //console.log(error);
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getSystemUserLeaveManageData(filter_type, system_admin, history) {
    return (dispatch) => {
        getSystemUserConfig(filter_type, system_admin)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getSystemUserLeaveAction(response.data));
                } else {
                    utility.showError(response.data.msg);
                }
                dispatch(globalLoadingAction(false));
            })
            .catch((error) => {
                //console.log(error);
                dispatch(globalLoadingAction(false));
            });
    };
}

export function getSystemConfigAction(data) {
    return {
        type: GET_SYSTEM_DEFAULT_LIST,
        payload: data,
    };
}
export function getSystemUserConfigAction(data) {
    return {
        type: GET_SYSTEM_USER_CONNFIC_DETAILS,
        payload: data,
    };
}

export function getSummaryConfigAction(data) {
    return {
        type: GET_SUMMARY_CONNFIC_DETAILS,
        payload: data,
    };
}


export function getSystemUserWeekOffDataAction(data) {
    return {
        type: GET_SYSTEM_USER_WEEKOFF_DETAILS,
        payload: data,
    };
}

export function getSystemUserLeaveAction(data) {
    return {
        type: GET_SYSTEM_USER_LEAVE_DETAILS,
        payload: data,
    };
}